import styled from 'styled-components';

export const MainAppContainer = styled.div`
  display: flex;
  min-height: calc(100vh - 64px);
  flex-direction: ${props => (props.direction ? props.direction : 'row')};
`;

export const QuillContainer = styled.div`
  width: 100%;
  & > div.length {
    position: absolute;
    bottom: ${({ isErrored }) => (isErrored ? '34px' : '12px')};
    right: 12px;
    font-size: 12px;
    line-height: 20px;
    color: #475867;
  }
  & > div.error {
    padding-left: 2px;
    padding-top: 4px;
    font-size: 12px;
    color: #d72d30;
  }
  .quill:hover {
    border-color: ${({ isErrored }) => (isErrored ? '#d72d30' : '#92a2b1')};
    transition: 0.2s linear;
  }
  .quill:focus-within {
    border-color: ${({ isErrored }) => (isErrored ? '#d72d30' : '#2c5cc5')};
    transition: 0.2s linear;
    box-shadow: ${({ isErrored }) =>
      isErrored ? 'unset' : '0 0 0 1px #2c5cc5'};
  }
  .quill {
    display: flex;
    flex-direction: column-reverse;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ isErrored }) => (isErrored ? '#d72d30' : '#cfd7df')};
    border-radius: 4px;
  }
  .ql-toolbar {
    border: none !important;
  }
  .ql-container {
    border: none !important;
  }
  .ql-editor::before {
    font-style: normal !important;
    font-size: 14px !important;
    color: #183247 !important;
    opacity: 0.3 !important;
  }
  .ql-editor {
    min-height: 120px !important;
    max-height: 220px !important;
    overflow: hidden;
    overflow-y: scroll;
    overflow-x: scroll;
  }
`;
